'use client';

import { Pagination } from '@aboutyou/backbone/endpoints/products/productsByIds';
import React, { FC } from 'react';
import { Container } from 'atoms/Container';
import { AlphabeticalItemsPage } from 'organisms/AlphabeticalItemsPage';
import { AlphabeticalItem } from 'organisms/AlphabeticalItemsPage/type';
import { FiltersProvider } from 'organisms/Filters/Context';
import { useFilterState } from 'organisms/Filters/hooks';
import { BrandsFilter } from 'pages/StoryBlok/ProductManualGrid/BrandsFilter';
import { ManualPagination } from 'pages/StoryBlok/ProductManualGrid/ManualPagination';
import { useRouter } from 'modules/i18n/navigation';
import { SortOptions } from 'commerce/factFinder/queryParameters';
import { Facets, IFilter, IFilterParam } from 'commerce/factFinder/types';

export const ProductManualGrid: FC<{
  products: AlphabeticalItem[];
  brands: IFilter[];
  pagination: Pagination;
  initFilters: IFilterParam[];
}> = ({ products, pagination, brands, initFilters }) => {
  const [stateFilters, setFilters] = useFilterState({
    initFilters,
    exclude: [Facets.CATEGORY_NAMES],
  });

  const { push } = useRouter();

  const handleSearch = (filters: IFilter[]) => {
    const params = new URLSearchParams({ page: pagination.page.toString() });

    filters.forEach((filter) => {
      params.append(filter.type as string, filter.value as string);
    });

    push(`?${params.toString()}`, {});
  };

  return (
    <Container>
      <FiltersProvider
        value={{
          filters: stateFilters,
          setFilters,
          facets: [],
          sortBy: {
            field: SortOptions.price,
            direction: 'asc',
          },
          setSortBy: () => {},
          sortOptions: [],
          handleSearch: () => handleSearch(stateFilters),
          handleReset: () => {
            setFilters([]);
            handleSearch([]);
          },
        }}
      >
        <BrandsFilter brands={brands} />
      </FiltersProvider>

      <AlphabeticalItemsPage
        tKey={'breadcrumbs.manuals-page'}
        items={products}
      />
      <ManualPagination page={pagination.page} count={pagination.last} />
    </Container>
  );
};
